import uniqBy from 'lodash/uniqBy';
import type { User } from './services/fetch-users/types';

export const getSelectedOptions = ({
	prevSelectedOptions,
	specialOptions,
	initialSearchData,
	data,
	value,
}: {
	prevSelectedOptions: User[];
	specialOptions: User[];
	initialSearchData: User[];
	data: User[];
	value: string[];
}): User[] =>
	uniqBy(
		[...specialOptions, ...initialSearchData, ...prevSelectedOptions, ...data].filter((acc) =>
			value.some((val) => val === acc.id),
		),
		'id',
	);

export const getOptions = ({
	search,
	specialOptions,
	initialSearchData,
	data,
	selectedOptions,
	isMulti,
}: {
	search: string;
	specialOptions: User[];
	initialSearchData: User[];
	data: User[];
	selectedOptions: ReadonlyArray<User>;
	isMulti: boolean;
}) =>
	uniqBy<User>(
		[
			...(search
				? [
						...specialOptions.filter((opt) =>
							opt.name.trim().toLowerCase().startsWith(search.toLowerCase()),
						),
						...data,
					]
				: [...specialOptions, ...initialSearchData]),
			/**
			 * Note: selectedOptions is ignored when the picker is in single
			 * picker mode. When isMulti is true, the AK user picker requires
			 * selected options to exist in the options prop in order to derive
			 * the selected values to display. When isMulti is false and a
			 * customer begins to type to search for a user, the AK user picker
			 * clears out the selected option. Therefore, there is no need to
			 * include the previous state of selected options to the user picker
			 * options - doing so would result in the incorrect behavior of the
			 * dropdown menu populated with the search result and previously
			 * selected option.
			 */
			...(isMulti ? selectedOptions : []),
		],
		'id',
	);
